document.addEventListener("DOMContentLoaded", function () {
  const root = document.getElementById("al-btw-calculator");
  if (!root) return;

  // -----------------------------
  // Ireland (simple, realistic model)
  // -----------------------------
  const IT_STANDARD_BAND = 44000;
  const IT_RATE_LOW = 0.20;
  const IT_RATE_HIGH = 0.40;

  const USC_BANDS = [
    { cap: 12012, rate: 0.005 },
    { cap: 28700, rate: 0.02 },
    { cap: 70044, rate: 0.03 },
    { cap: Infinity, rate: 0.08 }
  ];

  const PRSI_RATE = 0.042;

  const LIMITS = { electric: 1500, cargo: 3000 };

  const elSalary = document.getElementById("al-btw-salary");
  const elCost = document.getElementById("al-btw-cost");
  const elCalc = document.getElementById("al-btw-calc");
  const elEligible = document.getElementById("al-btw-eligible");
  const elSave = document.getElementById("al-btw-save");
  const elNet = document.getElementById("al-btw-net");
  const segBtns = Array.from(root.querySelectorAll(".al-btw-segbtn"));

  if (!elSalary || !elCost || !elCalc || !elEligible || !elSave || !elNet) return;

  let productType = "electric";

  // Salary dropdown
  const salaries = [];
  for (let s = 18000; s <= 120000; s += 1000) salaries.push(s);

  elSalary.innerHTML = salaries
    .map((s) => `<option value="${s}">${s.toLocaleString("en-IE")}</option>`)
    .join("");

  elSalary.value = "29000";

  segBtns.forEach((btn) => {
    btn.addEventListener("click", () => {
      segBtns.forEach((b) => b.classList.remove("is-active"));
      btn.classList.add("is-active");
      productType = btn.dataset.type;
      calculate();
    });
  });

  function eur(x) {
    const v = Math.max(0, Number(x) || 0);
    return "€" + v.toLocaleString("en-IE", { maximumFractionDigits: 0 });
  }

  function incomeTaxMarginalRate(annualGross) {
    const g = Math.max(0, Number(annualGross) || 0);
    return g < IT_STANDARD_BAND ? IT_RATE_LOW : IT_RATE_HIGH;
  }

  function uscMarginalRate(annualGross) {
    const g = Math.max(0, Number(annualGross) || 0);
    for (const band of USC_BANDS) {
      if (g <= band.cap) return band.rate;
    }
    return USC_BANDS[USC_BANDS.length - 1].rate;
  }

  function prsiMarginalRate(annualGross) {
    const g = Math.max(0, Number(annualGross) || 0);
    return g > 0 ? PRSI_RATE : 0;
  }

  function clamp01(x) {
    return Math.max(0, Math.min(1, x));
  }

  function calculate() {
    const salary = Math.max(0, Number(elSalary.value) || 0);
    const cost = Math.max(0, Number(elCost.value) || 0);

    const limit = LIMITS[productType] || 0;
    const eligible = Math.min(cost, limit);

    const it = incomeTaxMarginalRate(salary);
    const u = uscMarginalRate(salary);
    const p = prsiMarginalRate(salary);

    const totalMarginal = clamp01(it + u + p);

    const saving = eligible * totalMarginal;
    const excess = Math.max(0, cost - eligible);
    const netCost = Math.max(0, eligible - saving) + excess;

    elEligible.textContent = eur(eligible);
    elSave.textContent = eur(saving);
    elNet.textContent = eur(netCost);
  }

  elCalc.addEventListener("click", calculate);
  elSalary.addEventListener("change", calculate);
  elCost.addEventListener("input", calculate);

  calculate();
});